import { collection, addDoc, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const paymentsService = {
  async recordPayment(paymentData) {
    try {
      const paymentsRef = collection(db, 'payments');
      const payment = {
        ...paymentData,
        createdAt: new Date().toISOString()
      };
      const docRef = await addDoc(paymentsRef, payment);
      return { id: docRef.id, ...payment };
    } catch (error) {
      console.error('Error recording payment:', error);
      throw error;
    }
  },

  async getCustomerPayments(customerId) {
    try {
      console.log('Getting payments for customer:', customerId);
      const paymentsRef = collection(db, 'payments');
      
      // Temporary solution while index is being created
      const q = query(
        paymentsRef,
        where('customerId', '==', customerId)
        // orderBy removed temporarily
      );
      
      const snapshot = await getDocs(q);
      const payments = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Sort the results in memory
      payments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      
      console.log('Found payments:', payments);
      return payments;
    } catch (error) {
      console.error('Error fetching customer payments:', error);
      throw error;
    }
  }
};